export const MAX_ROLE_IDS = 1000;
export const MAX_ENGAGEMENT_IDS = 50;
export const ROLES_PER_PAGE = 25;
